import * as cmn from "../../common/NamaCommon";
import {nextId} from "../../common/NamaCommon";
import ApprovalEditTemplate from "../../compiled-templates/ApprovalEditTemplate";
import * as ts from "../../common/Translator";
import * as ApprovalDecision from "../../constants/ApprovalDecision";
import {currentLoginInfo} from "../../login/LoginPresenter";
import * as notifier from "../../common/ErrorsNotification";
import * as NamaURLS from "../../constants/NamaURLS";

export class MultiApproveDialog {
    constructor(presenter, entityTypes, entityIds, nextStepSequences) {
        this.presenter = presenter;
        this.entityTypes = entityTypes;
        this.entityIds = entityIds;
        this.nextStepSequences = nextStepSequences;
    }

    showPopup() {
        let that = this;
        if (!that.entityIds)
            return;
        that._initUI();
        that.rootElement.find("#approvedLinesDiv").remove();
        that.rootElement.find("#concernedLinesInp").remove();
        that.rootElement.find("#mainPart").remove();
        that.kendowWindow.open().center();
    }

    _initUI() {
        let that = this;
        that.elementId = nextId();
        that.rootElement = $(ApprovalEditTemplate({
            translateId: ts.translateId,
            elementId: that.elementId,
            approvalCase: {}
        }));
        /**
         * @type {kendo.ui.Window}
         */
        that.kendowWindow = that.rootElement.kendoWindow({
            title: ts.translateId("Approve"),
            maxWidth: "80%",
            maxHeight: "80%",
            minHeight: "50%",
            minWidth: "50%",
            resizable: true,
            scrollable: true,
            modal: true,
            actions: [
                "Close"
            ],
            close: function (e) {
                that.kendowWindow.data("kendoWindow").destroy()
            }
        }).data("kendoWindow");

        that.decisionCombo = that.rootElement.find("#" + that.elementId + "decisionCombo").kendoDropDownList({
            dataTextField: "text",
            dataValueField: "value",
            placeholder: ts.translateId("selectApproveDecision"),
            dataSource: [
                {text: ts.translateId(ApprovalDecision.Approve), value: ApprovalDecision.Approve},
                {text: ts.translateId(ApprovalDecision.Reject), value: ApprovalDecision.Reject},
                {text: ts.translateId(ApprovalDecision.Return), value: ApprovalDecision.Return},
                {text: ts.translateId(ApprovalDecision.EscalateToSupervisor), value: ApprovalDecision.EscalateToSupervisor}
            ],
            filter: "contains",
            suggest: true
        }).data("kendoDropDownList");

        let remarks = that.rootElement.find("#" + that.elementId + "remarksInput");
        let okBtn = that.rootElement.find("#" + that.elementId + "okBtn");
        let cancelBtn = that.rootElement.find("#" + that.elementId + "cancelBtn");

        okBtn.on("click", (e) => {
            let that = this;
            let employee = currentLoginInfo().userInfo.employee;
            if (employee == null)
                return;
            let approver = employee.id;
            let counter = 0;
            that.approveNext(that.decisionCombo.value(), remarks.val(), approver, counter);
            that.kendowWindow.destroy();
        });
        cancelBtn.on("click", (e) => {
            that.kendowWindow.destroy();
        })
    }

    approveNext(decision, comment, approver, i) {
        let that = this;
        let entityTypes = that.entityTypes;
        let entityIds = that.entityIds;
        let nextStepSequences = that.nextStepSequences;
        if (i >= entityIds.length) {
            that.presenter.onRefresh();
            return;
        }
        /**
         *
         * @type {namaTypes.ApproveRequest}
         */
        let request = {
            decision: decision,
            entityType: entityTypes[i],
            entityId: entityIds[i],
            comment: comment,
            stepSequence: nextStepSequences[i],
            approverId: approver
        };
        if (!decision) {
            notifier.showErrors("pleaseSelectDecision");
            return;
        }
        cmn.ajaxJSON(NamaURLS.APPROVE, {request: JSON.stringify(request)}, (record) => {
            if (!record.data) {
                notifier.showErrors("approvalRedirected");
                return;
            }
            i++;
            that.approveNext(decision, comment, approver, i);
        });
    }
}